import { createSelector } from 'reselect';

import { getAssignedLessonsCount } from 'common.components/user/selectors';

import { getTeacherCertificateStats } from '../../teacher-certificate-modal/selectors';

import { courseViewSelector } from './base.selectors';

/**
 * return true, if statistics popup was closed
 * @param {Object} store
 * @return {Boolean}
 */
export const getIsStatisticsModalClosed = createSelector(courseViewSelector, (state) => state.statisticsModalClosed);

export const getShouldShowCertificateBanner = createSelector(
    [getAssignedLessonsCount, getTeacherCertificateStats],
    (assignedLessonsCount, teacherCertificateStats) => {
        const { last_cancel: lastCancel, last_agree: lastAgree } = teacherCertificateStats || {};

        return assignedLessonsCount > 0 && !(lastCancel || lastAgree);
    }
);
